import type { SectionSpec } from './sections';

export function countDirty(dirty: Record<string, boolean>): number {
  let n = 0;
  for (const k in dirty) if (dirty[k]) n++;
  return n;
}

export function countDirtyBySection(
  sections: SectionSpec[],
  dirty: Record<string, boolean>,
): Record<string, number> {
  const out: Record<string, number> = {};
  for (const s of sections) {
    out[s.id] = s.fields.reduce((n, f) => n + (dirty[f] ? 1 : 0), 0);
  }
  return out;
}

/**
 * Whether an edited value is the stored value again (#2000).
 *
 * Arrays compare as multisets: a multi-select re-adds a toggled option at the
 * END, so unchecking and re-checking `campaign_name` yields the same selection
 * in a different order. Treating that as an edit sent the reordered array and
 * rewrote a settings document the operator never changed.
 */
export function isStoredValue(value: unknown, stored: unknown): boolean {
  if (Array.isArray(value) && Array.isArray(stored)) {
    if (value.length !== stored.length) return false;
    const key = (v: unknown) => JSON.stringify(v);
    const a = value.map(key).sort();
    const b = stored.map(key).sort();
    return a.every((v, i) => v === b[i]);
  }
  return JSON.stringify(value) === JSON.stringify(stored);
}
